module.exports = function() {
  return new Worker(__webpack_public_path__ + "914bcd3dc772cf94f689.worker.js");
};